export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/brand-mastercard.e6d33252.svg","height":16,"width":26,"blurWidth":0,"blurHeight":0};